<template>
  <div v-if="report">
    <p align="center" style="text-align:center"><b><span style="font-size:12.0pt"><span style="font-family:Arial">Отчет по менеджеру {{ report.user.fullname }} о статусе верификации компаний (с перечнем компаний)</span></span></b></p>

    <p>&nbsp;</p>

    <table class="MsoTableGrid" style="border-collapse:collapse; border:solid windowtext 1.0pt">
      <tbody>
      <tr style="height:24.05pt">
        <td rowspan="2" style="width:185.45pt; border:solid windowtext 1.0pt" width="185">
          <p align="center" style="text-align:center; padding:0cm 5.4pt 0cm 5.4pt"><span style="height:24.05pt"><b><span style="font-size:11.0pt"><span style="font-family:Arial">Менеджер</span></span></b></span></p>
        </td>
        <td colspan="4" style="width:251.5pt; border:solid windowtext 1.0pt; border-left:none" width="252">
          <p align="center" style="text-align:center; padding:0cm 5.4pt 0cm 5.4pt"><span style="height:24.05pt"><b><span style="font-size:11.0pt"><span style="font-family:Arial">Число компаний с определенным статусом</span></span></b></span></p>
        </td>
        <td rowspan="2" style="width:72.8pt; border:solid windowtext 1.0pt; border-left:none" width="73">
          <p align="center" style="text-align:center; padding:0cm 5.4pt 0cm 5.4pt"><span style="height:24.05pt"><b><span style="font-size:11.0pt"><span style="font-family:Arial">Итого по менеджеру</span></span></b></span></p>
        </td>
      </tr>
      <tr style="height:32.75pt">
        <td style="width:81.05pt; border-top:none; border-left:none; border-bottom:solid windowtext 1.0pt; border-right:solid windowtext 1.0pt" width="81">
          <p align="center" style="text-align:center; padding:0cm 5.4pt 0cm 5.4pt"><span style="height:32.75pt"><span style="font-size:11.0pt"><span style="font-family:Arial">Верификация</span></span></span></p>
        </td>
        <td style="width:95.3pt; border-top:none; border-left:none; border-bottom:solid windowtext 1.0pt; border-right:solid windowtext 1.0pt" width="95">
          <p align="center" style="text-align:center; padding:0cm 5.4pt 0cm 5.4pt"><span style="height:32.75pt"><span style="font-size:11.0pt"><span style="font-family:Arial">Участники инф. мероприятия</span></span></span></p>
        </td>
        <td style="width:75.15pt; border-top:none; border-left:none; border-bottom:solid windowtext 1.0pt; border-right:solid windowtext 1.0pt" width="75">
          <p align="center" style="text-align:center; padding:0cm 5.4pt 0cm 5.4pt"><span style="height:32.75pt"><span style="font-size:11.0pt"><span style="font-family:Arial">Кандидат</span></span></span></p>
        </td>
        <td style="width:75.15pt; border-top:none; border-left:none; border-bottom:solid windowtext 1.0pt; border-right:solid windowtext 1.0pt" width="75">
          <p align="center" style="text-align:center; padding:0cm 5.4pt 0cm 5.4pt"><span style="height:32.75pt"><span style="font-size:11.0pt"><span style="font-family:Arial">Архив</span></span></span></p>
        </td>
      </tr>
      <tr style="height:38.65pt">
        <td style="width:185.45pt; border:solid windowtext 1.0pt; border-top:none" width="185">
          <p align="center" style="text-align:center; padding:0cm 5.4pt 0cm 5.4pt"><span style="height:38.65pt"><span style="font-size:11.0pt"><span style="font-family:Arial">{{ report.user.fullname }}</span></span></span></p>
        </td>
        <td style="width:81.05pt; border-top:none; border-left:none; border-bottom:solid windowtext 1.0pt; border-right:solid windowtext 1.0pt" width="81">
          <p align="center" style="text-align:center; padding:0cm 5.4pt 0cm 5.4pt"><span style="height:38.65pt"><span style="font-size:11.0pt"><span style="font-family:Arial">{{report.total.verify}}</span></span></span></p>
        </td>
        <td style="width:95.3pt; border-top:none; border-left:none; border-bottom:solid windowtext 1.0pt; border-right:solid windowtext 1.0pt" width="95">
          <p align="center" style="text-align:center; padding:0cm 5.4pt 0cm 5.4pt"><span style="height:38.65pt"><span style="font-size:11.0pt"><span style="font-family:Arial">{{report.total.event}}</span></span></span></p>
        </td>
        <td style="width:75.15pt; border-top:none; border-left:none; border-bottom:solid windowtext 1.0pt; border-right:solid windowtext 1.0pt" width="75">
          <p align="center" style="text-align:center; padding:0cm 5.4pt 0cm 5.4pt"><span style="height:38.65pt"><span style="font-size:11.0pt"><span style="font-family:Arial">{{report.total.candidate}}</span></span></span></p>
        </td>
        <td style="width:75.15pt; border-top:none; border-left:none; border-bottom:solid windowtext 1.0pt; border-right:solid windowtext 1.0pt" width="75">
          <p align="center" style="text-align:center; padding:0cm 5.4pt 0cm 5.4pt"><span style="height:38.65pt"><span style="font-size:11.0pt"><span style="font-family:Arial">{{report.total.archive}}</span></span></span></p>
        </td>
        <td style="width:72.8pt; border-top:none; border-left:none; border-bottom:solid windowtext 1.0pt; border-right:solid windowtext 1.0pt" width="73">
          <p align="center" style="text-align:center; padding:0cm 5.4pt 0cm 5.4pt"><span style="height:38.65pt"><b><span style="font-size:11.0pt"><span style="font-family:Arial">{{report.total.all}}</span></span></b></span></p>
        </td>
      </tr>
      <tr style="height:20.85pt">
        <td style="width:185.45pt; border:solid windowtext 1.0pt; border-top:none" width="185">
          <p align="center" style="text-align:center; padding:0cm 5.4pt 0cm 5.4pt"><span style="height:20.85pt"><b><i><span style="font-size:11.0pt"><span style="font-family:Arial">Наименование компании</span></span></i></b></span></p>
        </td>
        <td colspan="2" style="width:176.35pt; border-top:none; border-left:none; border-bottom:solid windowtext 1.0pt; border-right:solid windowtext 1.0pt" width="176">
          <p align="center" style="text-align:center; padding:0cm 5.4pt 0cm 5.4pt"><span style="height:20.85pt"><b><i><span style="font-size:11.0pt"><span style="font-family:Arial">ОГРН</span></span></i></b></span></p>
        </td>
        <td colspan="3" style="width:147.95pt; border-top:none; border-left:none; border-bottom:solid windowtext 1.0pt; border-right:solid windowtext 1.0pt" width="148">
          <p align="center" style="text-align:center; padding:0cm 5.4pt 0cm 5.4pt"><span style="height:20.85pt"><b><i><span style="font-size:11.0pt"><span style="font-family:Arial">Статус</span></span></i></b></span></p>
        </td>
      </tr>
      <tr style="height:20.85pt" v-for="(company, key) in report.companies" :key="key">
        <td style="width:185.45pt; border:solid windowtext 1.0pt; border-top:none" width="185">
          <p style="padding:0cm 5.4pt 0cm 5.4pt"><span style="height:20.85pt"><span style="font-size:11.0pt"><span style="font-family:Arial">{{company.name}}</span></span></span></p>
        </td>
        <td colspan="2" style="width:176.35pt; border-top:none; border-left:none; border-bottom:solid windowtext 1.0pt; border-right:solid windowtext 1.0pt" width="176">
          <p align="center" style="text-align:center; padding:0cm 5.4pt 0cm 5.4pt"><span style="height:20.85pt"><span style="font-size:11.0pt"><span style="font-family:Arial">{{company.ogrn}}</span></span></span></p>
        </td>
        <td colspan="3" style="width:147.95pt; border-top:none; border-left:none; border-bottom:solid windowtext 1.0pt; border-right:solid windowtext 1.0pt" width="148">
          <p align="center" style="text-align:center; padding:0cm 5.4pt 0cm 5.4pt"><span style="height:20.85pt"><span style="font-size:11.0pt"><span style="font-family:Arial">{{company.status}}</span></span></span></p>
        </td>
      </tr>
      </tbody>
    </table>

    <p>&nbsp;</p>

    <p><span style="font-size:12.0pt"><span style="font-family:Arial">Регион: {{report.region}}</span></span></p>
    <p><span style="font-size:12.0pt"><span style="font-family:Arial">Дата отчета: {{date}}</span></span></p>

  </div>
</template>

<script>
    export default {
        name: "ManagerPrint",
        props: ['report'],
        data() {
            return {
                date: null
            }
        },
        mounted() {
            let today = new Date(),
                dd = today.getDate(),
                mm = today.getMonth() + 1;
            if (dd < 10) {
                dd = '0' + dd;
            }
            if (mm < 10) {
                mm = '0' + mm;
            }
            this.date = dd + '.' + mm + '.' + today.getFullYear();
        }
    }
</script>

<style scoped>

</style>
